import { Component, type ReactNode } from "react";

// Bir sayfadaki render hatası tüm uygulamayı (siyah ekran) çökertmesin diye sınır.
// Hata olursa hatayı ve yeniden dene butonunu gösterir, sidebar/layout korunur.
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: unknown }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };
  private lastAutoRetry = 0;

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  // Rota değişince hatayı otomatik sıfırla — kullanıcı başka sayfaya geçtiyse
  // eski sayfanın hatasında takılı kalmasın.
  componentDidUpdate(prev: { resetKey?: unknown }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  componentDidCatch(error: Error, info: unknown) {
    // Konsola da bas ki F12'de görünsün
    console.error("[ErrorBoundary] Sayfa render hatası:", error, info);
    // Bilinen DOM yarışı: sayfa geçişinde portal/unmount sırasında removeChild
    // NotFoundError fırlar (React'ın beklediği düğüm çoktan kalkmıştır). Zararsızdır ve
    // "Yeniden dene" hep düzeltir — aynı şeyi BİR KEZ otomatik yap (döngü koruması 4 sn).
    if (/removeChild|insertBefore|NotFoundError/i.test(String(error)) && Date.now() - this.lastAutoRetry > 4000) {
      this.lastAutoRetry = Date.now();
      setTimeout(() => this.setState({ error: null }), 60);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, maxWidth: 720, margin: "40px auto" }}>
          <div style={{ background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.4)", borderRadius: 12, padding: 20 }}>
            <h2 style={{ color: "#f04438", fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Bu sayfada bir hata oluştu</h2>
            <p style={{ color: "#70706c", fontSize: 13, marginBottom: 12 }}>Uygulama çökmedi — aşağıdaki hata mesajı sorunu gösteriyor:</p>
            <pre style={{ background: "#f4f4f2", border: "1px solid #e7e7e4", borderRadius: 8, padding: 12, fontSize: 12, color: "#1d1d1b", overflow: "auto", whiteSpace: "pre-wrap" }}>
              {/* Sayfa adresi hatanın başında: paketlenmiş yığında bileşen adı okunmuyor,
                  hangi ekranda patladığını ancak adres söylüyor (destek raporları için kritik) */}
              {`Sayfa: ${typeof window !== "undefined" ? window.location.pathname + window.location.search : "?"}\n\n`}
              {this.state.error.message}
              {"\n\n"}
              {this.state.error.stack?.split("\n").slice(0, 6).join("\n")}
            </pre>
            <button
              onClick={() => this.setState({ error: null })}
              style={{ marginTop: 14, background: "#e83e3c", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
            >
              Yeniden dene
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
